import React, { Component } from 'react';
import Map from './Map';

import { MapContainer } from './styles';

import ThrowMapError from './ThrowMapError';
import { ERROR_TYPE, ERROR_DETAIL } from './enums';

class ManifestMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorDetail: {
        message: null,
        icon: null,
        color: null,
        type: null,
      },
    };
  }

  _getErrorDetail = () => {
    this.setState({
      errorDetail: {
        message: ERROR_DETAIL.apiError.message,
        icon: ERROR_DETAIL.apiError.icon,
        color: ERROR_DETAIL.apiError.color,
        type: ERROR_TYPE.API_ERROR,
      },
    });
  };

  render() {
    const { errorDetail } = this.state;
    const { manifestInformation } = this.props;

    return (
      <MapContainer>
        {errorDetail && errorDetail.type === ERROR_TYPE.API_ERROR ? (
          <ThrowMapError
            message={errorDetail.message}
            icon={errorDetail.icon}
            color={errorDetail.color}
          />
        ) : (
          <Map
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<div className="AvailableVehicles__loading-el" />}
            containerElement={
              <div className="AvailableVehicles__container-el" />
            }
            mapElement={<div className="AvailableVehicles__map-el" />}
            isKeyAccount={false}
            manifestInformation={manifestInformation}
            performanceStatusCode={1}
            defaultZoom={11}
            getErrorDetail={this._getErrorDetail}
          />
        )}
      </MapContainer>
    );
  }
}

export default ManifestMap;
